import ApiBaseURLProps from "../other/apiBaseURL";
import axios from "axios";
import { authorizationHeader } from "./apiConfig";
import { setTypesOfBusinessOfCompany } from "../../redux/companySlice";

class PostApiService {
  async getCustomerUser() {
    return await axios.get(ApiBaseURLProps.apiBaseURL + "/kyc/customer", {
      ...authorizationHeader(),
    });
  }

  savePersonalDetails(data) {

    console.log(data, "family detailsaaaaaaaaaaaaaa");
    const personalDetails = data.personalDetails;
    const boidList = data.boidDetails.boidList;
    const bankDetails = data.bankDetails.bankDetailsList;
    const occupationDetails = data.occupationDetails;
    let guardianDetails = null;
    const addressDetails = data.addressDetails;
    const familyDetails = data.familyDetails.relativeList;
    const companyDetails = data.companyDetails;
    const directorDetails = data.directorDetails.directorDetailsList;
    let nDirectorDeatilList = [];
    for (let i = 0; i < directorDetails.length; i++) {
      nDirectorDeatilList.push({
        isAuthorized: directorDetails[i].authorizedPerson,
        directorTypeId: directorDetails[i].type,
        directorTypeOthers: directorDetails[i].directorTypeOthers,
        personDetail: {
          fname: directorDetails[i].firstName,
          mname: directorDetails[i].middleName,
          lname: directorDetails[i].lastName,
        },
        addressDetailList: [
          {
            addressTypeId: 2,
            countryCd: directorDetails[i].country,
            stateCd: directorDetails[i].state,
            districtCd: directorDetails[i].district,
            municipalityCd: directorDetails[i].municipality,
            ward: directorDetails[i].ward,
            tole: directorDetails[i].tole,
            blockNo: directorDetails[i].blockNo,
            phoneNo: directorDetails[i].telephoneNo,
            email: directorDetails[i].emailId,
            mobileNo: directorDetails[i].mobileNo,
          },
          {
            addressTypeId: 1,
            countryCd: directorDetails[i].perCountry,
            stateCd: directorDetails[i].perState,
            districtCd: directorDetails[i].perDistrict,
            municipalityCd: directorDetails[i].perMunicipality,
            ward: directorDetails[i].perWard,
            tole: directorDetails[i].perTole,
            blockNo: directorDetails[i].perBlockNo,
            phoneNo: directorDetails[i].perTelephoneNo,
          },
        ],
        familyDetailList: [
          {
            relationTypeId: "F",
            personDetail: {
              fname: directorDetails[i].fatherFirstName,
              mname: directorDetails[i].fatherMiddleName,
              lname: directorDetails[i].fatherLastName,
            },
          },
          {
            relationTypeId: "GF",
            personDetail: {
              fname: directorDetails[i].grandFatherFirstName,
              mname: directorDetails[i].grandFatherMiddleName,
              lname: directorDetails[i].grandFatherLastName,
            },
          },
          {
            relationTypeId: "SP",
            personDetail: {
              fname: directorDetails[i].spouseFirstName,
              mname: directorDetails[i].spouseMiddleName,
              lname: directorDetails[i].spouseLastName,
            },
          },
        ],
      });
    }
    const companyDetail = {
      name: companyDetails.companyName,
      ceoFirstName: companyDetails.ceoFirstName,
      ceoMiddleName: companyDetails.ceoMiddleName,
      ceoLastName: companyDetails.ceoLastName,
      secretaryFirstName: companyDetails.secFirstName,
      secretaryMiddleName: companyDetails.secMiddleName,
      secretaryLastName: companyDetails.secLastName,
      companyTypeCd: companyDetails.companyType,
      registrationDate: companyDetails.registrationDate,
      pan: companyDetails.panNo,
      dateOfIncop: companyDetails.incorporationDate,
      countryCd: companyDetails.countryOfRegistration,
      regOffice: companyDetails.registrationOffice,
      regNo: companyDetails.registrationNo,
      vatRegNo: companyDetails.panVatRegistrationNo,
      vatPanRegDate: companyDetails.registrationDate,
      businessTypeId: companyDetails.typesOfBusinessOfCompany,
      areaOfWork: companyDetails.areaOfWork,
      isListed: companyDetails.isListed,
      headOfficeName: companyDetails.nameAddressOfCompany,
      listingDate: companyDetails.listingDate,
      directorDetailList: nDirectorDeatilList,
      comapnyTypeOthers: companyDetails.companyTypeOthers,
      businessTypeOthers: companyDetails.businessTypeOthers,
    };

    console.log(data);
    const dynamicDataList = Object.values(
      data.dynamicFieldDetails.allDynamicField
    )
      .filter((d) => d.op && d.op !== "N")
      .map((d) => ({
        dynamicKey: d.dynamicKey,
        value: d.value,
        op: d.value ? "I" : "D",
      }));

    if (
      personalDetails.isMinor &&
      (data.guardianDetails.paop === "U" ||
        data.guardianDetails.pop === "U" ||
        data.guardianDetails.op === "U")
    ) {
      guardianDetails = {
        id: data.guardianDetails.id,
        op: data.guardianDetails.id ? "N" : "I",
        personDetail: {
          id: data.guardianDetails.pid,
          addressDetailList: [],
          op: data.guardianDetails.pid ? "N" : "I",
        },
      };

      if (data.guardianDetails.paop === "U") {
        guardianDetails.personDetail.addressDetailList.push({
          id: data.guardianDetails.paid,
          addressTypeId: 3,
          countryCd: data.guardianDetails.country,
          stateCd: data.guardianDetails.state,
          districtCd: data.guardianDetails.district,
          municipalityCd: data.guardianDetails.municipality,
          ward: data.guardianDetails.ward,
          tole: data.guardianDetails.tole,
          blockNo: data.guardianDetails.blockNo,
          phoneNo: data.guardianDetails.telephoneNo,
          email: data.guardianDetails.emailId,
          mobileNo: data.guardianDetails.mobileNo,
          fax: data.guardianDetails.fax,
          op: data.guardianDetails.paid ? "U" : "I",
        });
      }

      if (data.guardianDetails.pop === "U") {
        guardianDetails.personDetail.fname = data.guardianDetails.firstName;
        guardianDetails.personDetail.mname = data.guardianDetails.middleName;
        guardianDetails.personDetail.lname = data.guardianDetails.lastName;
        guardianDetails.personDetail.op = data.guardianDetails.id ? "U" : "I";
      }

      if (data.guardianDetails.op === "U") {
        guardianDetails.relationTypeId = data.guardianDetails.relationship;
        guardianDetails.personDetail.op = data.guardianDetails.id ? "U" : "I";
      }
    } else if (guardianDetails && guardianDetails.id) {
      guardianDetails = {
        id: guardianDetails.id,
        op: "D",
      };
    }

    let nBoidList = [];
    let dpId;
    let isForBoid;
    let isForMeroShareId = data.boidDetails.createMeroShareId;
    for (let i = 0; i < boidList.length; i++) {
      if (boidList[i].isForwarded) {
        dpId = boidList[i].dpId;
      }
      if (boidList[i].op !== "N")
        nBoidList.push({
          id: boidList[i].id,
          boId: boidList[i].boid,
          dpId: boidList[i].dpId,
          isForwarded: boidList[i].isForwarded,
          op: boidList[i].id ? "U" : "I",
        });
    }

    for (let i = 0; i < data.boidDetails.rList.length; i++) {
      nBoidList.push({
        id: data.boidDetails.rList[i],
        op: "D",
      });
    }

    if (!data.boidDetails.hasBoid) {
      for (let i = 0; i < boidList.length; i++) {
        nBoidList.push({
          id: boidList[i],
          op: "D",
        });
      }

      dpId = data.boidDetails.fdpId;
      isForBoid = data.boidDetails.createBoid;
    }

    let nBankAccountDeatilList = [];
    for (let i = 0; i < bankDetails.length; i++) {
      if (bankDetails[i].op !== "N")
        nBankAccountDeatilList.push({
          id: bankDetails[i].id,
          accountNo: bankDetails[i].bankAccountNumber,
          accountType: bankDetails[i].typesOfBankAccount,
          bankId: bankDetails[i].bank,
          op: bankDetails[i].id ? "U" : "I",
          isPrimaryAccount: bankDetails[i].isPrimaryAccount,
        });
    }

    for (let i = 0; i < data.bankDetails.rList.length; i++) {
      nBankAccountDeatilList.push({
        id: data.bankDetails.rList[i],
        op: "D",
      });
    }

    let nFamilyList = [];
    for (let i = 0; i < familyDetails.length; i++) {

      if (
        (familyDetails[i].op === "U" || familyDetails[i].pop === "U") &&
        (familyDetails[i].firstName ||
          familyDetails[i].middleName ||
          familyDetails[i].lastName)
      )
        nFamilyList.push({
          id: familyDetails[i].id,
          relationTypeId: familyDetails[i].relativeTypeId,
          op: familyDetails[i].id ? familyDetails[i].op : "I",
          personDetail: {
            id: familyDetails[i].pid,
            fname: familyDetails[i].firstName,
            mname: familyDetails[i].middleName,
            lname: familyDetails[i].lastName,
            op: familyDetails[i].pid ? familyDetails[i].pop : "I",
          },
        });
    }

    const isMinor = data.personalDetails.isMinor;
    const nationality = data.personalDetails.nationality;
    const personDocumentDetailList = data.documentDetails.documentList
      .filter(
        (p) =>
          p.op === "U" &&
          (p.documentTypeId === "PH" ||
            ((p.documentTypeId === "CZ" || p.documentTypeId === "NI") &&
              p.type === "I" &&
              nationality === "NP") ||
            ((p.documentTypeId === "PP" ||
              (isMinor && p.documentTypeId === "NR")) &&
              p.type === "I" &&
              nationality !== "NP") ||
            !["CZ", "NI", "PP", "NR"].includes(p.documentTypeId))
      )
      .map((d) => ({
        ...d,
        op: d.id ? "U" : "I",
        documentTypeDesc: undefined,
        documentTypeDescNp: undefined,
        issuedFromDesc: undefined,
        type: undefined,
        issuedDate:
          d.issuedDate &&
          ("" + JSON.parse(JSON.stringify(d.issuedDate))).split("T")[0],
      }));

    data.documentDetails.documentList
      .filter(
        (p) =>
          p.id &&
          !(
            ((p.documentTypeId === "CZ" || p.documentTypeId === "NI") &&
              p.type === "I" &&
              nationality === "NP") ||
            ((p.documentTypeId === "PP" ||
              (isMinor && p.documentTypeId === "NR")) &&
              p.type === "I" &&
              nationality !== "NP") ||
            !["CZ", "NI", "PP", "NR"].includes(p.documentTypeId)
          )
      )
      .forEach((p) => {
        personDocumentDetailList.push({ id: p.id, op: "D" });
      });

    const addressDetailList = [];
    if (addressDetails.pop === "U") {
      addressDetailList.push({
        id: addressDetails.pid,
        addressTypeId: 1,
        countryCd: addressDetails.perCountry,
        stateCd: addressDetails.perState,
        districtCd: addressDetails.perDistrict,
        municipalityCd: addressDetails.perMunicipality,
        ward: addressDetails.perWard,
        tole: addressDetails.perTole,
        blockNo: addressDetails.perBlockNo,
        phoneNo: addressDetails.perTelephoneNo,
        op: addressDetails.pid ? "U" : "I",
      });
    }

    if (addressDetails.op === "U") {
      addressDetailList.push({
        id: addressDetails.id,
        addressTypeId: 2,
        countryCd: addressDetails.country,
        stateCd: addressDetails.state,
        districtCd: addressDetails.district,
        municipalityCd: addressDetails.municipality,
        ward: addressDetails.ward,
        tole: addressDetails.tole,
        blockNo: addressDetails.blockNo,
        phoneNo: addressDetails.telephoneNo,
        email: addressDetails.emailId,
        mobileNo: addressDetails.mobileNo,
        op: addressDetails.id ? "U" : "I",
      });
    }

    const occupationDetailList = [];

    if (
      occupationDetails.op === "U" ||
      occupationDetails.companyDetailsList.find((c) => c.op !== "N") ||
      occupationDetails.rConpanyList.length
    ) {
      if (occupationDetails.op === "U") {
        occupationDetailList.push({
          id: occupationDetails.id,
          financialStatus: occupationDetails.financialDetails,
          designation: occupationDetails.designation,
          address: occupationDetails.address,
          orgName: occupationDetails.organizationName,
          occupationTypeId: occupationDetails.occupationType,
          businessTypeId: occupationDetails.businessType,
          docId: occupationDetails.docId,
          op: occupationDetails.id ? "U" : "I",
        });
      } else {
        occupationDetailList.push({
          id: occupationDetails.id,
          op: "N",
        });
      }

      occupationDetailList[0].investmentCompanyList =
        occupationDetails.companyDetailsList
          .filter((c) => c.op !== "N")
          .map((companyDetails) => ({
            id: companyDetails.id,
            name: companyDetails.companyName,
            designation: companyDetails.companyDesignation,
            op: companyDetails.op,
          }));

      for (let i = 0; i < occupationDetails.rConpanyList.length; i++) {
        occupationDetailList[0].investmentCompanyList.push({
          id: occupationDetails.rConpanyList[i],
          op: "D",
        });
      }
    }

    let personDetails = {};

    if (personalDetails.op !== "N") {
      personDetails = {
        id: personalDetails.id,
        fname: personalDetails.firstName,
        mname: personalDetails.middleName,
        lname: personalDetails.lastName,
        fnameNep: personalDetails.firstNameNep,
        mnameNep: personalDetails.middleNameNep,
        lnameNep: personalDetails.lastNameNep,
        gender: personalDetails.gender,
        dob: personalDetails.dob,
        countryCd: personalDetails.nationality,
        pan: personalDetails.pan,
        isMinor: personalDetails.isMinor,
        isNrn: personalDetails.isNrn,
        op: personalDetails.id ? "U" : "I",
      };
    } else {
      personDetails = {
        id: personalDetails.id,
        op: personalDetails.id ? "N" : "I",
      };
    }

    const postData = {
      id: data.personalDetails.customerId,
      isForBoid,
      isForMeroShareId, // Similar to isCreateBoid
      dpId,
      personDetail: {
        ...personDetails,
        addressDetailList: addressDetailList,
        occupationDetailList: occupationDetailList,
        guardianDetail: guardianDetails,
        familyDetailList: nFamilyList,
        personDocumentDetailList,
      },
      bankAccountDetailList: nBankAccountDeatilList,
      boIdList: nBoidList,
      dynamicDataList,
    };
    console.log("postData", postData);
    return axios.post(ApiBaseURLProps.apiBaseURL + "/kyc/save", postData, {
      ...authorizationHeader(),
    });
  }

  // submitPersonalDetails(customerId) {
  //   return axios.post(
  //     ApiBaseURLProps.apiBaseURL + "/kyc/submit?customerId=" + customerId,
  //     null,
  //     {
  //       ...authorizationHeader(),
  //     }
  //   );
  // }
  saveVideoKycEventSlot(obj, formattedTime) {
    return axios.post(
      ApiBaseURLProps.apiBaseURL + "/video-kyc/kycVideo/saveVideoKycEvent?formattedTime=" + formattedTime,
      obj,
      {
        ...authorizationHeader(),
      }
    );
  }

  cancelKycVideoSessionBooking() {
    return axios.post(
      ApiBaseURLProps.apiBaseURL + "/video-kyc/kycVideo/cancelKycVideoSessionBooking",
      null,
      {
        ...authorizationHeader(),
      }
    );
  }
}

export default new PostApiService();
